
<template>
    <ListDetailLayout
		    :store="assetTypesStore"
        index-route-name="admin.assets.types"
		    create-permissions="create:asset-types"
		    @on-create="$router.push({ name: 'admin.assets.types.type', params: { type: 'NEW' } })"
		    @on-paginate="(page) => useOnPaginate(page, refreshAssetTypes, params)"
		    @on-search="(page) => useOnSearch(page, refreshAssetTypes, params)"
			create-button-admin-page="create-asset-type-btn"
			search-admin-page="search-asset-type-admin-page"
    >

        <template #list>
            <li v-for="type in assetTypesStore.getAssetTypes" :key="type.id">
                <router-link :to="{ name: 'admin.assets.types.type', params: { type: type.id } }" v-slot="{isActive}">
                    <div :class="[isActive ? 'border-primary-500 dark:bg-surface-600' : 'border-transparent hover:bg-surface-50 dark:hover:bg-surface-800', 'transition-colors border-l-4 flex items-center justify-between gap-x-6 py-5 pl-3 pr-4 bg-surface-0 dark:bg-surface-800']">

                        <div class="min-w-0">
                            <div class="flex items-start gap-x-3">
                                <p class="text-sm font-semibold leading-6 text-surface-900 dark:text-surface-200">{{ type.name }}</p>
                            </div>

		                        <div class="mt-1 flex items-center gap-x-2 text-xs leading-5 text-surface-500 dark:text-surface-400">
				                        <p class="whitespace-nowrap">
					                          {{ type.company?.name ?? $t('common.public') }}
				                        </p>
		                        </div>
                        </div>

                    </div>
                </router-link>
            </li>
        </template>

        <template #detail>
            <router-view v-if="$route.params.type" @on-save="refreshAssetTypes" @on-delete="refreshAssetTypes"></router-view>
        </template>

    </ListDetailLayout>
</template>

<script>
import ListDetailLayout from "@/Layouts/ListDetailLayout.vue";
import Container from "@/Components/Container.vue";
import { mapStores } from "pinia";
import { useAssetTypesStore } from "@/stores/assetTypes.js";
import { useOnPaginate, useOnSearch } from "@/Composables/Pagination.js";

export default {
	name: "AssetTypesIndex",
	data() {
		return {
			params: {
				include: ['company'],
			}
		}
	},
	methods: {
		useOnSearch,
		useOnPaginate,
		refreshAssetTypes(){
			return this.assetTypesStore.indexAssetTypes(this.params);
		}
	},
	components: {Container, ListDetailLayout},
	computed: {
		...mapStores(useAssetTypesStore)
	},
	async mounted() {
		await this.refreshAssetTypes();
	}
}
</script>
